export enum ModelSource {
    platform = 'Trained on the Platform',
    uploaded = 'Uploaded by User',
    onPremise = 'Trained On-Premise',
}
